const host = globalThis.location.hostname;

export const isDev = ['localhost', 'develop.'].some(env => host.startsWith(env));

export const isDevOrDemo = ['localhost', 'develop.', 'demo.'].some(env => host.startsWith(env));
export const isDevDemoOrTest = ['localhost', 'develop.', 'demo.', 'test.'].some(env => host.startsWith(env));

export const isUnitTesting = import.meta.env.MODE === 'test';
